<template>
  <div class="manual-payments">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" />
    <div class="filters">
      <div class="search">
        <div class="option">
          <span>Seller</span>
          <artmisads-select :clearable="true" show-search v-model:value="filters.sellerId" style="width: 232px" :options="sellerOptions"
            @search="searchSeller" :show-arrow="false" :filter-option="false" :not-found-content="null"
            @change="handleChangeSeller" placeholder="All" allowClear />
        </div>
        <div class="option" ref="marketplaceRef">
          <span>Marketplace</span>
          <!-- <artmisads-input v-model:value="filters.marketplace" @press-enter="getPartData({})"
            placeholder="Enter Marketplace"></artmisads-input> -->
          <artmisads-select :clearable="true" style="width: 232px" v-model:value="filters.marketplace"
            :getPopupContainer="() => marketplaceRef" :options="COUNTRY_BASE_OPTIONS" />
        </div>
        <div class="option">
          <span>Brand</span>
          <artmisads-select :clearable="true" show-search v-model:value="filters.brandId" style="width: 232px" :options="brandOptions"
            @search="searchBrand" :show-arrow="false" :filter-option="false" :not-found-content="null" placeholder="All"
            allowClear />
        </div>
        <div class="option">
          <span>Publisher</span>
          <artmisads-select :clearable="true" show-search v-model:value="filters.publisherId" style="width: 232px"
            :options="publisherOptions" @search="searchPublisher" :show-arrow="false" :filter-option="false"
            :not-found-content="null" placeholder="All" allowClear />
        </div>
        <div class="option" ref="statusRef">
          <span>creatDate</span>
          <a-date-picker :clearable="true" :show-time="true" format="YYYY-MM-DD HH:mm:ss" v-model:value="filters.createdAtStart" style="width: 232px"/>      
        </div>
      
        <div class="option" ref="statusRef">
          <span>Status</span>
          <artmisads-select :clearable="true" style="width: 232px" v-model:value="filters.status"
            :getPopupContainer="() => statusRef" :options="STATUS_OPTIONS" />
        </div>
        <div class="option" ref="statusRef">
          <span>Period Start Date</span>
          <a-date-picker @change="handleChangeDate" :clearable="true"  format="YYYY-MM-DD" v-model:value="filters.startDateStr" style="width: 232px"/>      
        </div>
        <div class="option" ref="statusRef">
          <span>Period End Date</span>
          <a-date-picker @change="handleChangeDate" :clearable="true"  format="YYYY-MM-DD" v-model:value="filters.endDateStr" style="width: 232px"/>      
        </div>
      </div>
     
    </div>
    <div class="button">
        <artmisads-button isSquare="true" type="primary" style="margin-right: 12px" :loading="load"
          @click="searchList">Search</artmisads-button>
        <artmisads-button isSquare="true" @click="onReset">Reset</artmisads-button>
    </div>
    <div class="add">

      <artmisads-button isSquare="true" type="primary" @click="exportData">
        Export
      </artmisads-button>

    </div>
    <div class="table-data">
      <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="dataList"
        :change="onTableChange" :loading="load" :scroll="{ x: 1600, y: tableScrollHeight }">
        <template #bodyCell="{ record, index, column }">
          <template v-if="column.key === 'creatDate'">
            {{ record.createdAt &&
              moment(Number(record.createdAt)).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template v-if="column.key === 'period'">
            {{ moment(Number(record.startDate)).tz(BILLING_TIME_TZ[record.marketplace]).format('YYYY-MM-DD HH:mm:ss') }}
            - {{ moment(Number(record.endDate)).tz(BILLING_TIME_TZ[record.marketplace]).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template v-if="column.key === 'sellerEmail'">
            <div>
              {{ record.sellerName }}
            </div>
            {{ record.sellerEmail }}
          </template>
          <template v-if="column.key === 'commission'">
            {{ record.commissionRate }}%
          </template>
          <template v-if="column.key === 'status'">
            <Status :type="record.status.toLowerCase()" :noBorder="true"
              :text="record.status == 'active' ? 'Active' : 'Inactive'" />
          </template>
        </template>
      </artmisads-table>
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue'
import breadcrumbs from '../breadcrumbs.vue'
import { COUNTRY_BASE } from '~/contants/common'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'
import Status from '@/components/Status.vue'
import { financeApi } from '~/server/operator/finance'
import moment from 'moment'
import { BILLING_TIME_TZ } from '~/contants/common'
import { publisherAdminApi } from '~/server/index'
import { useUserInfoStore } from '@/storeData'

import { CURRENCY_MAPPER,COUNTRY_SITE_CODE_MAP } from '~/contants/common'
const STATUS_OPTIONS = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Inactive',
    value: 'inactive',
  },
]
const columns = [
  {
    title: 'CreatDate',
    key: 'creatDate',
    dataIndex: 'creatDate',
    align: 'center',
  },
  {
    title: 'Marketplace',
    dataIndex: 'marketplace',
    key: 'marketplace',
    align: 'center',
  },
  {
    title: 'Seller',
    dataIndex: 'sellerEmail',
    key: 'sellerEmail',
    align: 'center',
  },
  {
    title: 'Brand',
    dataIndex: 'brandName',
    key: 'brandName',
    align: 'center',
  },
  {
    title: 'Publisher',
    dataIndex: 'publisherName',
    key: 'publisherName',
    align: 'center',
  },
  {
    title: 'Period',
    dataIndex: 'period',
    key: 'period',
    align: 'center',
  },
  {
    key: 'Commission',
    dataIndex: 'commission',
    title: 'Commission',
    align: 'center',
    key: 'commission',
  },

  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
  },
]
const user = useUserInfoStore()
const countryCode = user?.userInfo?.countryCode || 'US'
const marketplace = CURRENCY_MAPPER[countryCode].host
const options = ref([])
const userId = ref('')
const dataList = ref([])
const modelRef = ref(null)
const pagination = reactive({
  current: 1,
  defaultPageSize: 10,
  size: 10,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
})
const marketplaceRef = ref(null)
const statusRef = ref(null)
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host
  item.label = item.host
  return item
})
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-data',
  bottomSpace: 280,
  minHeight: 200,
  maxHeight: 1000,
  defaultHeight: 350,
})
const load = ref(false)
const statusOptions = ref([
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Paid',
    value: 'Paid',
  },
  {
    label: 'Unpaid',
    value: 'Unpaid',
  },
])
const breadcrumbsData = ref({
  title: 'Associate Partnerships',
  des: '',
  links: [
    {
      name: 'Home',
      path: '/operator/users',
    },
    {
      name: 'Operation',
      path: '/operator/operation/manualPayments',
    },
    {
      name: 'Associate Partnerships',
      path: '/operator/operation/sensitiveProducts',
    },
  ],
})
const sellerOptions = ref([])
const filters = ref({
  sellerId: '',
  marketplace: '',
  brandId: '',
  publisherId: '',
  createdAtStart: '',
  status: '',
  startDateStr: '',
  endDateStr: '',
})
const brandOptions = ref([])
const publisherOptions = ref([])
const handleChangeDate = (date, dateString) => {
  if(dateString){
    filters.value.marketplace = 'amazon.com'
  }
}
const userInfoArr = ref([])
const optionsAsin = ref([])
const onSearch = (e) => {
  const parma = {
    email: e,
  }
  // getUser(parma)
}
const onSelect = (e) => {
  const res = userInfoArr.value.find((v) => v.userId == e)
  filters.value.email = res.email
  userId.value = res.userId

}
// const getUser = async (parma) => {
//   const res = await financeApi.getSensitiveProducts(parma)
//   let data = res.filter((v) => v.userType === 'seller')
//   options.value = data.map((item) => ({
//     label: item.email,
//     value: item.userId,
//   }))
//   userInfoArr.value = data
// }
const searchSeller = async keyword => {
  const params = {
    keyword,
    marketplace: marketplace
  }
  let data = await publisherAdminApi.searchSeller(params)
  if (data && data.length) {
    data = data.map(item => {
      item.value = item.id
      item.label = item.sellerName
      item.sellerBrands = item.sellerBrands.map(i => {
        i.value = i.id
        i.label = i.amazonBrandName
        return i
      })
      return item
    })
    sellerOptions.value = data
  }
}
const searchBrand = async keyword => {
  const params = {
    keyword,
    marketplace: marketplace
  }
  let data = await publisherAdminApi.searchBrand(params)
  if (data && data.length) {
    data = data.map(item => {
      item.value = item.id
      item.label = item.amazonBrandName
      return item
    })
    brandOptions.value = data
  }
}
const searchPublisher = async keyword => {
  const params = {
    keyword,
    marketplace: marketplace
  }
  let data = await publisherAdminApi.searchPublisher(params)
  if (data && data.length) {
    data = data.map(item => {
      item.value = item.id
      item.label = item.creatorName
      return item
    })
    publisherOptions.value = data
  }
}
const searchList = async () => {
  // console.log(filters.value)
  pagination.current = 1
  getData(filters.value)
}
// setTimeout(() => {
//   modelRef.value.show()
// }, 1000);
const bulkUpdateModelRef = ref(null)
const bulkUpdate = () => {
  bulkUpdateModelRef.value.open()
}
const exportData = () => {
  const params = {
    ...filters.value,
    page: pagination.current,
    size: pagination.size,
  }
   if(params.createdAtStart){
     const time=params.createdAtStart.format('YYYY-MM-DD HH:mm:ss')
 
    params.createdAtStart = moment(time).valueOf()
    // params.createdAtStart = params.createdAtStart.valueOf()
  }
  if(params.marketplace){
    params.countryCode = COUNTRY_SITE_CODE_MAP[params.marketplace]
  }
  financeApi.associateproductDealExport({
    qs: params,
    fileName: `associate_partnerships_${moment().format('YYYY-MM-DD')}.csv`,
    platform: 'operator'
  })
}
const addManualPayment = () => {
  modelRef.value.show()
}

const onReset = () => {
  filters.value = {
    sellerId: '',
  marketplace: '',
  brandId: '',
  publisherId: '',
  createdAtStart: '',
  status: '',
  startDateStr: '',
  endDateStr: '',
  }
  getData({})
}
const onTableChange = ({ current, pageSize }) => {
  // console.log(current, pageSize,'数据')
  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  getData({ page: current, size: pageSize })
}
const getData = async (params) => {
  load.value = true
  if (Object.keys(params).length === 0) {
    pagination.current = 1
  }
  let _params = {
    page: pagination.current,
    size: pagination.size,
    ...filters.value,
    // marketplace: filters.marketplace,
    // sellerId: filters.sellerId,
    // bd: filters.bd
  }
  console.log(_params,'_params')
  if(_params.createdAtStart&&params.createdAtStart){
    const time=params.createdAtStart.format('YYYY-MM-DD HH:mm:ss')
 
    _params.createdAtStart = moment(time).valueOf()
  }
  if(_params.marketplace){
    _params.countryCode = COUNTRY_SITE_CODE_MAP[_params.marketplace]
  }
  if(_params.startDateStr&&params.startDateStr){
     _params.startDateStr=params.startDateStr.format('YYYY-MM-DD')

  }
  if(_params.endDateStr&&params.endDateStr){
     _params.endDateStr=params.endDateStr.format('YYYY-MM-DD')
 
  }
  let newparams = { ..._params }
  newparams = Object.keys(newparams).reduce((acc, key) => {
    if (
      newparams[key] !== null &&
      newparams[key] !== undefined &&
      newparams[key] !== ''
    ) {
      acc[key] = newparams[key]
    }
    return acc
  }, {})
  financeApi
    .getSensitiveProducts(newparams)
    .then((res) => {

      if (res.success) {
        dataList.value = res.data.data
        pagination.total = res.data.total
      }
    })
    .finally(() => {
      load.value = false
    })
}

const edit = (record) => {
  console.log(record, 'record')
}
const view = (record) => {
  console.log(record, 'record')
}
const revoke = (record) => {
  console.log(record, 'record')
}
// getData({})
onMounted(() => {
  getData({})
})
// setTimeout(() => {
//   modelRef.value.show()
// }, 1000);
</script>
<style scoped lang="less">
.button{
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
  justify-content: flex-end;
}
.autoComplete {
  :deep(.ant-select-selector) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-search-input) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-placeholder) {
    line-height: 32px !important;
  }
}

.add {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
  gap: 12px;
}

.manual-payments {
  padding: 16px;
  padding-top: unset;
  width: 100%;
}

.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;

  :deep(.ant-table) {
    border-radius: 8px 8px 0 0;
  }

  :deep(.ant-table-cell) {
    padding-left: 8px;
    padding-right: 8px;

    >a {
      color: var(--primary);

      &:hover {
        color: var(--primary-hover);
      }
    }
  }

  :deep(.ant-table-thead) {
    border-radius: 8px 8px 0 0;
  }

  .user {
    flex: 1;

    .user-name {
      color: var(--dark-1);
      font-weight: 500;
      font-size: 16px;
      letter-spacing: 0.4px;
      line-height: 20px;

      >span {
        font-weight: 400;
        margin-left: 4px;
      }
    }

    .user-email {
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 16px;
      padding: 10px 0;
    }

    .user-id {
      height: 16px;
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      line-height: 16px;
    }
  }

}

.filters {
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .option {
      >span {
        margin-right: 8px;
      }

      display: flex;
      align-items: center;
      margin-right: 24px;
    }
  }
}
</style>
